import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './References.css';

const References = () => {
  const [references, setReferences] = useState([]);

  useEffect(() => {
    const referencesRef = ref(database, 'references');
    const unsubscribe = onValue(referencesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const referencesList = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        setReferences(referencesList);
      } else {
        setReferences([]);
      }
    });

    return () => unsubscribe();
  }, []);

  // Slider için referansları çoğalt (sonsuz döngü için)
  const duplicatedReferences = references.length > 0 
    ? [...references, ...references, ...references]
    : [];

  return (
    <section id="references" className="references">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Referanslarımız</h2>
          <p className="section-subtitle">
            Bulut Ambalaj olarak birçok işletmeye hizmet vermekten gurur duyuyoruz.
          </p>
        </div>
        {references.length === 0 ? (
          <div className="references-empty">
            <p>Referans henüz eklenmedi.</p>
          </div>
        ) : (
          <div className="references-slider-wrapper">
            <div className="references-slider">
              {duplicatedReferences.map((reference, index) => (
                <div key={`${reference.id || index}-${Math.floor(index / references.length)}`} className="reference-item">
                  {reference.image ? (
                    <img src={reference.image} alt={reference.title} className="reference-image" />
                  ) : null}
                  <h3>{reference.title}</h3>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default References;
